import { render, staticRenderFns } from "./TagTrail.vue?vue&type=template&id=4e92d267&scoped=true"
import script from "./TagTrail.vue?vue&type=script&lang=js"
export * from "./TagTrail.vue?vue&type=script&lang=js"
import style0 from "./TagTrail.vue?vue&type=style&index=0&id=4e92d267&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e92d267",
  null
  
)

export default component.exports